var perPage = 9;
let globleQuery;
$(document).ready(function(){

  // 17-07-2023
  $(".btn_specification").click(function () {
    $('.btn_specification_detail').slideToggle();
  });

  $('.mainmenu > ul').addClass('mobile-menu');
  $('.mainmenu li:has(ul)').addClass('parent');
  $('.mainmenu > ul > li.parent ul').addClass('sub-menu');
  if( $('.mobile-menu').length > 0 ){
    $('.mobile-menu').before('<button type="button" class="ebiz-toggle"><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></button>');
  }
  if( $('.mobile-menu li.parent').length > 0 ){
    $('.mobile-menu li.parent > ul').before('<span class="mobile-toggle"></span>');
  }
  $(".ebiz-toggle").click(function(){
    $(this).toggleClass("ebiz-menuopen");
    $(".mobile-menu").slideToggle(200);
  });
  $('.mainmenu .mobile-toggle').click(function() {
    $(this).parent().siblings('.parent').find('span.mobile-toggle').removeClass('ebiz-subopen');
    $(this).parent().siblings('.parent').find('.sub-menu').slideUp(250);
    $(this).next('.sub-menu').slideToggle(250);
    $(this).next('.sub-menu').children('.parent').find('.sub-menu').slideUp(250);
    $(this).next('.sub-menu').children('.parent').find('span.mobile-toggle').removeClass('ebiz-subopen');
    $(this).toggleClass('ebiz-subopen');
    return false;
  });

  $('.icon-wrap .serch-icon a,.search-modal.modal__content .search-modal__content .search-modal-content-wrap button.search-modal__close-button').click(function(e){
    e.preventDefault();
    $('.search-modal.modal__content.gradient').fadeToggle();
  });

  $('.product-image-slide').slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    fade: true,
    autoplay: false,
    autoplaySpeed: 2000,
    adaptiveHeight: true,
    infinite: false
  });

  var sliderfor = $('.shop-now-slider-section .slider-for').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  dots:false,
	  fade: true,
      infinite: false,
	  asNavFor: '.shop-now-slider-section .slider-nav'
	});
	var slidernav = $('.shop-now-slider-section .slider-nav').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  asNavFor: '.shop-now-slider-section .slider-for',
	  dots: false,
	  arrows: true,
      infinite: false
	});

  $('.shop-now-slider-section .slider-nav').each(function(){
    $(this).find('.slick-next').wrap('<div class="slick-arrow-wrap"></div>');
    $($(this).find('.slick-prev')).insertBefore($(this).find('.slick-next'));
    $($(this).find('.slick-arrow-wrap')).insertAfter($(this).find('.shop-now-slider-section  .right-wrap .slider-nav'));
  });

  if (window.matchMedia('(max-width:767px)').matches) {
    $(".fabric-collection-wrap button.filter-btn").click(function(){
      $(".fabric-collection-wrap .filter-wrap").slideToggle();
    });
  }

  $('.fabric-swatches-slider').slick({
  infinite: true,
  slidesToShow:4,
  slidesToScroll: 1,
  arrows: true,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
      ]
});

  $('.our-happy-customers-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 1,
    infinite: false
  });

  $('.happy-customer-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 1,
    infinite: false
  });
  $('.happy-customer-slider').each(function(){
    $(this).find('.slick-next').wrap('<div class="slick-arrow-wrap"></div>');
    $($(this).find('.slick-prev')).insertBefore($(this).find('.slick-next'));
    $($(this).find('.slick-arrow-wrap')).insertAfter($(this).find('.happy-customer-with-image .happy-customer-slider .name-text'));
  });

  const accorLength = $('.faq-wrap .accorbox_box').length;
  if (window.matchMedia('(max-width: 767px)').matches) {
        $('.faq-wrap .accorbox_box').slice(0,accorLength).wrapAll('<div class="col"/>');
    } else {
        $('.faq-wrap .accorbox_box').slice(0,Math.ceil(accorLength/2)).wrapAll('<div class="col"/>');
        $('.faq-wrap .accorbox_box').slice(Math.ceil(accorLength/2),accorLength).wrapAll('<div class="col"/>');
    }

  $('.faq-wrap .col').each(function(){
    $(this).find(".accorbox_box").first().find('.title').addClass('active')
     $(this).find(".accorbox_box").first().find('.title').next().slideDown(500)
  })

  $(".accorbox_box .title").click(function() {
    $(this).parents('.col').find('.accorbox_box .title').not($(this)).removeClass('active');
    $(this).parents('.col').find('.accorbox_box .text').not($(this).next()).slideUp();
    $(this).toggleClass('active');
    $(this).next().slideToggle(500);
  });


  $(".fabric-collection-wrap .filter-wrap .filter").first().find('.filter-title').addClass('active')
  $(".fabric-collection-wrap .filter-wrap .filter").first().find('.filter-title').next().slideDown(500)
  $(".fabric-collection-wrap .filter-wrap .filter .filter-title").click(function() {
      $('.fabric-collection-wrap .filter-wrap .filter .filter-title').not($(this)).removeClass('active');
      $('.fabric-collection-wrap .filter-wrap .filter ul').not($(this).next()).slideUp();
      $(this).toggleClass('active');
      $(this).next().slideToggle(500);
  });


  $('.product-tab ul li:first-child').addClass('active');
  $('.product-content').hide();
  $('.product-content:first').show();
  // Click function
  $('.product-tab ul li').click(function(){
    $('.product-tab ul li').removeClass('active');
    $(this).addClass('active');
    $('.product-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $(document).on('change', '.custom-filter input[type="checkbox"]',function(e){
    e.preventDefault();
    let filterUrl = createFilter();
    applyFilter(filterUrl);
  });

  $(document).on('change', '.ajax-collection select[name="sort_by"]', function (e) {
    e.stopPropagation();
    let filterUrl = createFilter();
    applyFilter(filterUrl);
  });

  $(document).on('click', '.ajax-collection .pagination__item', function (e) {
    e.preventDefault();
    $('.pagination__item')
      .removeClass('pagination__item--current')
      .removeAttr('aria-disabled');

    $(this).addClass('pagination__item--current').attr('aria-disabled', true);

    let filterUrl = createFilter();
    applyFilter(filterUrl);
  });

});

function createFilter(){
  let sortBY = $('select[name="sort_by"]').val();
  let collectionHandle = $('.collection-section').attr('data-handle');
  let pageNo = $('.pagination__item--current').text();
  let selectedFilters = [];
  $('.custom-filter input:checked').each(function(i,v){
    let filter =  $(this).parents('li').attr('data-tag')
    selectedFilters.push(filter);
  });

  let filterString;
  if(selectedFilters.length){
    filterString = '/collections/'+collectionHandle+'/'+selectedFilters.join('+')+'?sort_by='+sortBY+'&page='+pageNo;
  } else {
    filterString = '/collections/'+collectionHandle+'/?sort_by='+sortBY+'&page='+pageNo;
  }
  return filterString;
}

function applyFilter(filterUrl){
    $.ajax({
      type: "get",
      url: filterUrl,
      dataType: 'html',
      success: function (data) {
        $('html, body').animate({
          scrollTop: $(".facets__form").offset().top
        }, 500)

        let responseData = $(data).find('.collection-ajax'),
            productValue = $(data).find('.grid__item').length;

        if (productValue > 0) {
            $('.collection').html(responseData);
        } else {
            $('.collection').html("<h3>No Product Available for this combination.</h3>");
        }
        history.pushState("", "", filterUrl);
      }
    });
}
